import React from 'react';

export const FormGroup = ({ label, children, htmlFor }) => (
    <div className="form-group">
        {label && <label className="form-label" htmlFor={htmlFor}>{label}</label>}
        {children}
    </div>
);

export const Input = React.forwardRef(({ className = '', ...props }, ref) => {
    return (
        <input
            ref={ref}
            className={`form-input ${className}`}
            {...props}
        />
    );
});

Input.displayName = 'Input';

export const Textarea = React.forwardRef(({ className = '', ...props }, ref) => {
    return (
        <textarea
            ref={ref}
            className={`form-input ${className}`}
            {...props}
        />
    );
});

Textarea.displayName = 'Textarea';

export const Select = React.forwardRef(({ className = '', children, isLoading, ...props }, ref) => {
    return (
        <div className="select-wrapper">
            <select
                ref={ref}
                className={`form-select ${isLoading ? 'is-loading' : ''} ${className}`}
                disabled={isLoading || props.disabled}
                {...props}
            >
                {isLoading ? <option value="">Carregando dados...</option> : children}
            </select>
            {isLoading && (
                <span className="select-spinner">
                    <svg className="animate-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <circle cx="12" cy="12" r="10" strokeWidth="4" strokeLinecap="round" strokeDasharray="31.415, 31.415"></circle>
                    </svg>
                </span>
            )}
        </div>
    );
});

Select.displayName = 'Select';

export const Button = React.forwardRef(({ className = '', variant = 'primary', children, isLoading, ...props }, ref) => {
    return (
        <button
            ref={ref}
            className={`btn btn-${variant} ${className}`}
            disabled={isLoading || props.disabled}
            {...props}
        >
            {isLoading ? (
                <>
                    <svg className="animate-spin" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: 16, height: 16 }}>
                        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeDasharray="31.415, 31.415" transform="rotate(0, 12, 12)" />
                    </svg>
                    Carregando...
                </>
            ) : children}
        </button>
    );
});

Button.displayName = 'Button';
